export enum ChannelTypes {
	SMS = "sms",
	EMAIL = "email",
	TELEGRAM = "telegram",
	WHATSAPP = "whatsapp",
}
